<template>
  <div class="admperformReport">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <reportType :wayString="wayString" :placehold="placehold" :Title="Title"></reportType>
      </el-main>
    </PageNav>
  </div>
</template>
<script>
import PageNav from "../../components/Nav/nav.vue";
import reportType from "../../components/report/reportType";
import storeanalysisreport from "./analysisreport.js";
export default {
  name: "analysisreport-admperformReport",
  data() {
    return {
      openMenu: ["8"],
      wayString: "channelClientReport", //传递到子组件的方法名称
      Title: this.$t("Analysisreport.aa"),
      placehold: "" //传递到子组件的placehold
    };
  },
  components: {
    PageNav,
    reportType
  },
  created() {
    
    this.slider = this.$store.state.Slider;
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less">
@import url("../../assets/less/manage.less");
@import url("analysisreport.less");
.admperformReport {
  // height: 100vh;
  font-size: 20px;
}
</style>
